
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/writing-best-practices",
      function () {
        return require("private-next-pages/writing-best-practices/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/writing-best-practices"])
      });
    }
  